
<script>
    import LZString from 'lz-string';

    export default {
        props: ['op'],
        methods: {

            makeObjectParam(jsonObj){

                let jsonString = JSON.stringify(jsonObj);

                return LZString.compressToEncodedURIComponent(jsonString)

            },

            getObjectParam(){
                return this.parseObjectParam(this.op);
            },

            parseObjectParam(op){

                if (!op){
                    op = this.op;
                }

                if (op){
                    let jsonString = LZString.decompressFromEncodedURIComponent(op);

                    return JSON.parse(jsonString);
                }
                else {
                    return null;
                }

            },

        },
    }

</script>